<template>
  <div>
    <el-page-header @back="goBack(-1)" content="模块更新" title="返回">
    </el-page-header>
    <el-row class="margin_top">
      <el-col :span="1">{{ oldData.id }}</el-col>
      <el-col :span="2">{{ oldData.serviceName }}</el-col>
    </el-row>
    <el-row class="margin_top">
      <el-col :span="8" style="border-right: 1px solid #ccc;">
        <div class="info">
          集成：{{ oldData.unitAlias }}_{{ oldData.unitVersion }}
        </div>
        <div class="info">
          模块类型：{{ oldData.moduleType }}
        </div>
        <div class="info">
          模块版本：{{ oldData.moduleVersion }}
        </div>
      </el-col>
      <el-col :span="12" style="margin-left:20px;">
        <div class="info">
          <el-select v-model="newData.unitId" @change="selectUnit">
            <el-option v-for="(option, index ) in unitList"
                       :key="index"
                       :label="option.alias + '_' + option.version"
                       :value="option.id">
              <span style="float: left">{{ option.alias }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ option.version }}</span>
            </el-option>
          </el-select>
        </div>
        <div class="info">
          模块类型：{{ newData.moduleType }}
        </div>
        <div class="info">
          模块版本：{{ newData.moduleVersion }}
        </div>
      </el-col>
    </el-row>
    <el-row v-if="isNew" class="margin_top" style="font-size:24px;">
      <i class="el-icon-success" style="color:#67C23A;"></i>当前已是最新版本
    </el-row>
    <el-row class="margin_top" v-if="isNew === false">
      <el-button v-if="nodeId" type="primary" @click="createInstance">
        创建实例
      </el-button>
      <span v-else>
        <el-button type="primary" @click="addNodeId">新增业务ID</el-button>
      </span>

      <div v-if="newData.id" style="display:inline-block;margin-left:10px;">
        <el-button v-if="process.percent == -1" type="primary"
                   @click="instanceDownload">下载</el-button>
        <el-button v-else type="primary">{{ process.text }}</el-button>

        <el-button v-if="!oldData.docker" type="primary" @click="setResource">检查资源</el-button>
        <el-button v-if="!oldData.docker" type="primary" @click="checkDepend">检查依赖</el-button>
        <div v-if="!oldData.docker" class="moduleClass">
          <el-button v-if="setResourceSuccess && oldData.editDep"
                     type="primary" @click="configVerify">配置文件更新
          </el-button>
        </div>
        <div v-else class="moduleClass">
          <el-button type="primary" @click="configVerify">配置文件更新</el-button>
        </div>
      </div>
    </el-row>


    <el-row class="margin_top" v-if="allInstanceDepende.length > 0">
      <h3>依赖该实例的实例：</h3>
      <el-tag v-for="(item, index) in allInstanceDepende"
              :key="index" effect="dark" type="success"
              style="margin-right:4px;"
      >{{ '实例' + item.id }}
      </el-tag>
    </el-row>

    <el-row class="margin_top" v-show="showConfig">
      <h3>配置文件列表：</h3>
      <config-list ref="configRef" :oldData="oldData" :newData="newData"/>
    </el-row>

    <el-row class="margin_top">
      <el-button type="primary" @click="goBack">关闭</el-button>
    </el-row>

    <set-source v-if="showSource" :visible="showSource"
                :deviceId="oldData.deviceId"
                :module="oldData.moduleType"
                :moduleVersion="newData.moduleVersion"
                :instanceId="newData.id"
                :hasServiceHelper="newData.hasServiceHelper"
                :resourceId="newData.resourceId"
                :oldDataId="oldData.id"
                @sourceCallback="sourceCallback"/>

    <dependency v-if="showDepend" :visible="showDepend"
                :instanceId="newData.id"
                :isEdit="oldData.editDep"
                :module="oldData.moduleType"
                :instanceInfo="{
                hasServiceHelper:newData.hasServiceHelper,
                id: newData.id,
                device: {
                  serviceAgentId:newData.serviceAgentId
                }
                }"
                @dependCallback="dependCallback"
    />

    <el-dialog
      title="提示"
      :visible="inputView"
      width="25%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false">
      <el-form label-position="left" :model="formData" ref="formData" label-width="90px">
        <el-form-item prop="nodeId" label="指定业务ID:">
          <el-input v-model="formData.nodeId" placeholder="请输入" style="width: 150px"></el-input>
        </el-form-item>
      </el-form>
      <el-row style="text-align:center;margin-top: 20px">
        <el-button type="primary" @click="addnewNodeID()">绑 定</el-button>
        <el-button @click="inputView = false">取 消</el-button>
      </el-row>
    </el-dialog>


    <el-dialog title="添加定时任务" :visible.sync="taskView">
      <el-form :model="taskForm">
        <el-form-item label="ID">
          <el-button type="text" style="margin-left: 50px">{{ oldData.id }}</el-button>
        </el-form-item>
        <el-form-item label="任务类型">
          <el-button type="text" v-if="taskType=='restart'" style="margin-left: 9px">重启</el-button>
          <el-button type="text" v-if="taskType=='update'" style="margin-left: 9px">更新</el-button>
        </el-form-item>
        <el-form-item label="执行时间">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm"
            v-model="execTime"
            type="datetime"
            placeholder="选择执行时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="配置文件">
          <el-button type="primary" size="small" @click="chooseFile">选择配置文件</el-button>
          <span v-if="showTaskFile">
<el-table :data="taskFileList" style="width: 100%">
      <el-table-column prop="configName" label="文件名称" width="180"></el-table-column>
      <el-table-column prop="location" label="路径" width="180"></el-table-column>
    </el-table>
          </span>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="saveTask">确 定</el-button>
        <el-button @click="taskView = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="配置文件列表" :visible.sync="ListView">
      <el-table :data="fileListData" ref="taskFileTable"
                @selection-change="chooseTaskFile">
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column align="center" prop="name" label="文件名称"></el-table-column>
        <el-table-column align="center" prop="location" label="路径"></el-table-column>
        <el-table-column align="center" prop="version" label="版本号"></el-table-column>
        <el-table-column align="center" prop="function" label="描述"></el-table-column>
        <el-table-column align="center" prop="creator" label="创建者"></el-table-column>
      </el-table>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="saveSelectedFile">确 定</el-button>
        <el-button @click="ListView = false">取 消</el-button>
      </div>
    </el-dialog>


  </div>
</template>
<script>
import {Loading} from "element-ui";
import ConfigList from './ModuleUpdateConfig'
import SetSource from './SetSource.vue'
import Dependency from './Dependency'
import {mapMutations, mapState} from 'vuex';


export default {
  components: {ConfigList, SetSource, Dependency},
  data() {
    return {
      oldData: {
        configList: [],
      },
      newData: {
        id: '', //实例id
        unitId: '', //集成版本的id
        configList: [],
        resourceId: '',
        statusId: '',
        hasServiceHelper: '',
        serviceAgentId: null
      },
      unitList: [], //集成列表
      relationProxyList: [],
      clickTimes: 0,
      nodeId: "",
      formData: {
        nodeId: ""
      },
      inputView: false,
      taskView: false,
      showTaskFile: false,
      taskForm: {},
      viewNetPlaneItme: null,
      addrGroupNodes: [],
      selectIdx: 0,
      // resourceOk: false, //是否分配完资源
      showConfig: false, //是否显示配置文件列表
      isNew: null, //是否是最新版本
      showSource: false,
      ListView: false,
      // createSuccess: false, //是否创建实例成功
      showDepend: false, //依赖
      allInstanceDepende: [], //所有依赖该模块的实例
      setResourceSuccess: false,
      moduleUpdateflag: false,
      suspensionShow: false,
      process: {
        percent: -1, //下载进度
        text: '下载中'
      },
      processText: '下载中',
      UnitList: [],
      moduleArray: [], //模块列表
      proxyId: "",
      idcId: "",
      fileListData: [],
      taskFileList: [],
      newInstanceId: "",
      taskType: "",
      execTime: "",
      selectedFile: "",
    }
  },
  created() {
    const params = this.$route.params;
    this.oldData = Object.assign(this.oldData, params);
    if (this.oldData.unitAlias && this.oldData.unitVersion) {
      this.getUnitUpgradeList()
    }
    this.getNodeId();
  },
  computed: {
    ...mapState(['socketInfo']),
  },
  watch: {
    socketInfo: {
      handler(newVal, oldVal) {
        const data = newVal;
        if (this.newData.id == data.insId) {
          const progress = data.progress;
          const value = data.value;
          const percent = data.percent;
          // 实例下载过程
          if (progress == 19) {
            if (this.process.percent > percent) {
              return
            }
            this.process.text = (percent + '%');
            this.process.percent = percent;
            if (percent == 100) {
              this.process.text = '下载完成'
            }
          }
        }
      },
      deep: true
    }
  },
  methods: {
    saveSelectedFile() {
      this.showTaskFile = true;
      this.ListView = false;
    },
    chooseFile() {
      this.ListView = true;
      if (this.oldData.docker == true) {
        this.getDockerConfigList();
      } else {
        this.getAllConfigList();
      }
    },
    saveTask() {
      let data = {
        instanceId: this.oldData.id,
        newInstanceId: this.newData.id,
        taskType: this.taskType,
        execTime: this.execTime,
        config: this.selectedFile
      };
      this.currentTime = new Date().Format('yyyy-MM-dd hh:mm:ss');
      let currentT = new Date(this.currentTime).getTime() / 1000;
      let execT = new Date(this.execTime).getTime() / 1000;
      if (execT < currentT + 600) {
        this.$message.error('执行时间需晚于当前时间十分钟！');
        return
      }
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'deploy/timerTask/addTask', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.taskView = false;
            this.$router.push({
              name: 'deployinstancelist',
              params: {
                currentPage: this.oldData.currentPage
              }
            });
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    chooseTaskFile(val) {
      this.taskFileList = [];
      let arr = [];
      arr = this.$refs["taskFileTable"].selection;
      arr.forEach(e => {
        this.taskFileList.push({
          location: e.location+"",
          configName: e.name,
        })
      });
      this.selectedFile = JSON.stringify(this.taskFileList);
    },
    addnewNodeID() {
      let data = {
        nodeId: parseInt(this.formData.nodeId),
        instanceId: this.oldData.id,
        moduleType: this.oldData.moduleType
      };
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/node/insert', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.formData.nodeId = "";
            _this.inputView = false;
            this.getUnitUpgradeList();
            this.getNodeId();
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    addNodeId() {
      this.$confirm('直接新增业务ID 或 输入指定业务ID?', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '直接新增',
        cancelButtonText: '输入指定业务ID',
        type: 'warning'
      }).then(() => {
        this.addnewNodeID();
      }).catch((action) => {
        if (action == "close") {

        } else if (action == "cancel") {
          this.formData.nodeId = "";
          this.inputView = true
        }
      });
    },
    getNodeId() {
      let data = {
        instanceId: this.oldData.id,
        moduleType: this.oldData.moduleType
      };
      this.$axios.post(this.baseUrl3 + 'management3/node/findByInsId', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data) {
              this.nodeId = data.nodeId;
            } else {
              this.$message.warning("当前实例未绑定业务ID！")
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    reset(progress) {
      this.$axios.get(this.baseUrl3 + "instance/reset/status/"
        + this.newData.id + '/'
        + this.newData.statusId + '/'
        + progress + '/'
        + 1)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            // this.$emit('itemCallback')
          } else {
            // this.$message({ showClose: true, message: msg, type: "error" })
            console.log(msg)
          }
        }).catch(err => {
        // this.$message.error('请求失败')
        console.log(err)
      });
    },
    goBack(flag) {
      if (flag == -1) {
        if (this.oldData.idcId) {
          this.$router.push({
            path: 'idcdevicelist',
            name: 'idcdevicelist',
            params: {
              idcId: this.oldData.idcId
            }
          });
        } else {
          this.$router.push({
            name: 'deployinstancelist',
            params: {
              currentPage: this.oldData.currentPage
            }
          })
        }
        return
      } else {
        if (this.oldData.idcFlag) {
          this.bind();
        }
      }
      if (this.$refs.configRef) {
        console.log(this.$refs.configRef.configList);
        if (this.$refs.configRef.configList) {
          // 所有的配置文件是否都已配置，如果是，将当前实例重置为配置状态
          let hasUnDeployed = this.$refs.configRef.configList.some(c => c.passed != true);
          if (!hasUnDeployed) {
            this.reset(9)
          }
        } else {
          this.reset(9)
        }
      }
      // this.$router.push('instancelist')
      // this.$router.push({
      //     name: 'deployinstancelist',
      //     params: {
      //         currentPage: this.oldData.currentPage
      //     }
      // })
      if (this.newData.id) {
        let loading = Loading.service({
          fullscreen: true,
          text: "数据加载中..."
        });
        this.$axios.get(this.baseUrl3 + 'config/repack/'
          + this.newData.id + '/'
          + this.newData.moduleType + '/'
          + this.newData.moduleVersion)
          .then(({data: {data, msg, code}}) => {
            if (code != 20000) {
              this.$message.error(msg);
              return
            }
            if (this.oldData.moduleType == "butelproxy") {
              this.updateProxy();
            } else {
              // this.updateAnother();
            }
            if (this.oldData.isInstall == 1) {
              if (this.oldData.moduleType != "service_agent") {
                this.$confirm('是否添加定时任务？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.taskView = true;
                  this.taskType = "update";
                  this.execTime = null;
                  this.taskFileList = [];
                  this.showTaskFile = false;
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  });
                  this.$router.push({
                    name: 'deployinstancelist',
                    params: {
                      currentPage: this.oldData.currentPage
                    }
                  });
                });
              } else {
                this.$router.push({
                  name: 'deployinstancelist',
                  params: {
                    currentPage: this.oldData.currentPage
                  }
                });
              }


            } else {
              this.$router.push({
                name: 'deployinstancelist',
                params: {
                  currentPage: this.oldData.currentPage
                }
              });
            }
            loading.close()
          })
          .catch(err => {
            console.log(err);
            loading.close()
          })
      } else {
        this.$router.push({
          name: 'deployinstancelist',
          params: {
            currentPage: this.oldData.currentPage
          }
        })
      }
    },
    getAllConfigList() {
      if (!this.oldData.moduleVersion || !this.oldData.moduleType) {
        return;
      }
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.fileListData = [];
      this.$axios
        .get(
          this.moduleUrl +
          "config/get/listByNameAndVersion/" +
          this.oldData.moduleType +
          "/" +
          this.oldData.moduleVersion
        )
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            data.forEach(d => {
              if (!d.location) {
                d.location = null
              }
              if (d.name.indexOf(".service") != -1) {
                d.name = this.serviceName + ".service";
              }
            });
            this.fileListData = data;
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        });
    },
    getDockerConfigList() {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.fileListData = [];
      let url = this.baseUrl3 + "config/cat/all/" + this.oldData.id;
      this.$axios.get(url)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data && data.length > 0) {
              data.forEach(d => {
                if (!d.location) {
                  d.location = null
                }
              });
              this.fileListData = data;
            } else {
              this.$message({showClose: true, message: "当前模块没有配置文件", type: "warn"});
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        });
    },
    updateProxy() {
      let data = {
        instanceId: this.oldData.id,
        newInstanceId: this.newData.id
      };
      this.$axios.post(this.baseUrl3 + 'management3/instance/UpdateProxyInfoByInstanceId', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {

          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // updateAnother() {
    //   this.relationProxyList = []
    //   this.$axios.get(this.baseUrl3 + "management3/instance/GetProxyListByInstanceId/"
    //     + this.oldData.id)
    //     .then(({data: {msg, data, code}}) => {
    //       if (code == 20000) {
    //         if (data) {
    //           this.suspensionShow = true;
    //           data.forEach(e => {
    //             this.relationProxyList.push({
    //               proxyId: e.proxyId,
    //               idcId: e.idcId,
    //               oldInstanceId: this.oldData.id
    //             })
    //           })
    //           localStorage.setItem("relationProxyList", JSON.stringify(this.relationProxyList));
    //         }
    //
    //       } else {
    //         this.$message({showClose: true, message: msg, type: "error"});
    //         console.log(msg)
    //       }
    //     }).catch(err => {
    //     console.log(err)
    //   });
    // },
    // 检查依赖
    checkDepend() {
      // findById
      // 检查： 实例管理-查询
      // 保存依赖/instance/saveDependency
      if (this.oldData.docker == true) {
        this.setResourceSuccess = true;
        this.oldData.editDep = true;
      } else {
        this.showDepend = true
      }
    },
    // 建立依赖回调
    dependCallback(val) {
      if (val == true) {
        this.oldData.editDep = true
      }
      this.showDepend = false
    },
    // 查询所有依赖该实例的实例
    getAllInstanceDepende() {
      this.$axios
        .get(this.baseUrl3 + "instance/findByDependency/" + this.oldData.id)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.allInstanceDepende = data ? data : []
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    bind() {
      let model = {
        deviceId: this.oldData.deviceId,
        serviceAgentId: this.newData.id
      };
      this.$axios.post(this.baseUrl3 + 'management3/device/bind', model)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 创建实例-升级
    createInstance() {
      // this.newData.id = 80
      //  this.newData.resourceId = 80
      //  return
      // 查询依赖该实例的实例
      this.getAllInstanceDepende();
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });

      const selectedItem = this.unitList.find(unit => unit.id == this.newData.unitId);

      this.$axios
        .get(this.baseUrl3 + "instance/upgrade/" + this.oldData.id + '/' + selectedItem.alias + '/' + selectedItem.version + '/' + this.newData.moduleVersion + '/' + this.newData.hasServiceHelper)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.newData.id = data.instanceId;
            this.newData.resourceId = data.resourceId;
            this.newData.statusId = data.statusId;
            this.newData.serviceId = data.serviceId;
            this.newData.serviceAgentId = data.agentId;

            console.log(data);
            //创建实例后发送id订阅ws
            this.websocket.subIds.push(this.newData.id)
            this.websocket.ws.send(this.newData.id);
            // this.websocketsend(this.newData.id);
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close()
        })
        .catch(err => {
          console.log(err);
          loading.close()
        });
    },
    resetItems() {
      this.isNew = false;
      this.showConfig = false;
      this.newData.id = '';
      this.newData.resourceId = '';
      // this.newData.moduleVersion = '';
      this.$set(this.newData, 'moduleVersion', null)
    },
    // 获取集成列表
    getUnitUpgradeList() {
      this.$axios
        .get(this.moduleUrl + "integration/Version/upgrade/list/"
          + this.oldData.unitAlias + '/' + this.oldData.unitVersion)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.unitList = data
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        })
        .catch(err => {
          console.log(err)
        });
    },
    // 选择集成后，查询实例的模块版本是否一致
    selectUnit(id) {
      this.resetItems();

      const selectedItem = this.unitList.find((item) => item.id == id)

      this.$axios
          .get(this.moduleUrl + "integration/Version/" + selectedItem.alias + '/' + selectedItem.version)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data.moduleList && data.moduleList.length > 0) {
              const hasModule = data.moduleList.filter(obj => obj.moduleName == this.oldData.moduleType)
              if (hasModule.length > 0) {
                let mType = '_win';
                if (this.oldData.moduleVersion.indexOf('_centos') != -1) {
                  mType = '_centos'
                }
                for (let i = 0; i < hasModule.length; i++) {
                  if (hasModule[i].moduleVersion.indexOf(mType) != -1) {
                    this.newData.moduleType = hasModule[i].moduleName;
                    this.newData.moduleVersion = hasModule[i].moduleVersion;
                    this.newData.hasServiceHelper = hasModule[i].hasServiceHelper;
                    break;
                  }
                }
                if (!this.newData.moduleType) {
                  this.newData.moduleType = hasModule[0].moduleName;
                  this.newData.moduleVersion = hasModule[0].moduleVersion;
                  this.newData.hasServiceHelper = hasModule[0].hasServiceHelper
                }
                if (this.newData.moduleVersion == this.oldData.moduleVersion) {
                  this.isNew = true
                } else {
                  this.isNew = false
                }
                // this.isNew = false // test data
              } else {
                this.isNew = true
              }
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 分配资源
    // 首先查看是否需要分配资源，如果不需要，继续往下走；如果需要，弹框分配资源
    setResource() {
      // this.showSource = true
      // return
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      // setTimeout(() => {
      //   loading.close();
      // }, 1000);
      this.$axios
        .get(this.baseUrl3 + "instance/compare/" + this.oldData.moduleType + '/' +
          this.oldData.moduleVersion + '/' + this.newData.moduleVersion
        )
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data == true) {
              this.showSource = true;
              this.moduleUpdateflag = true;
            } else {
              this.$message.success('不需要重新分配资源');
              this.reset(18);
              this.setResourceSuccess = true
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close()
        })
        .catch(err => {
          console.log(err);
          loading.close()
        });
    },
    // 分配资源回调
    sourceCallback(val) {
      if (val != false) {
        let loading = Loading.service({
          fullscreen: true,
          text: "数据加载中..."
        });
        let model = {
          content: val,
          id: this.newData.resourceId
        };
        this.$axios.post(this.baseUrl3 + "instance/register/resource", model)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.$message.success('操作成功');
              this.showSource = false;
              this.setResourceSuccess = true;
            } else {
              this.$message({showClose: true, message: msg, type: "error"});
              console.log(msg);
            }
            loading.close();
          }).catch(err => {
          this.$message.error('操作失败');
          loading.close();
        });
      } else {
        this.showSource = false
      }
    },
    // 配置文件校正
    configVerify() {
      this.showConfig = true;
      this.clickTimes += 1;
      if (this.clickTimes > 0) {
        this.$refs.configRef.profileUpgrade()
      }
    },
    // 实例下载
    instanceDownload() {
      this.$axios
        .get(this.baseUrl3 + "instance/download/deploy/" + this.newData.id)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.$message.success("下载成功");
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
    // websocketsend(data) {
    //   this.websock.send(data);
    // },
    websocketonmessage(e) {
      //数据接收
      if (e) {
        // 获取到的对象不为空
        if (e.data != null && Object.keys(e.data).length != 0) {
          let data = JSON.parse(e.data);
          console.log('instance-upgrade-message:');
          console.log(data);
          const _this = this;
          let tr;
          if (this.newData.id == data.insId) {
            const progress = data.progress;
            const value = data.value;
            const percent = data.percent;
            // 实例下载过程
            if (progress == 19) {
              this.process.text = percent + '%'
            }
          }
        }
      }
    },
  }
}
</script>
<style>
.el-table .showLight {
  background: #ffa9eb;
}
</style>
<style scoped>


.margin_top {
  margin-top: 20px;
}

.info {
  height: 40px;
  line-height: 40px;
}

.result {
  margin-left: 20%;
}

.moduleClass {
  display: inline-block;
  margin-left: 10px;
}
</style>
